import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);

export default {
    filters:{
        comma (number) {
            return String(number).replace(/[^0-9]/g,'').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
    },
    methods: {
        isFieldEmpty (val) {
            return typeof val === 'object' && Array.isArray(val)
                ? !val.length
                : typeof val === 'object' && !Array.isArray(val) && !!val
                    ? !Object.keys(val).length
                    : !val || val.toString().trim() === '';
        },
        generateSubcomponentDataBy (sub) {
            let {
                sub_code, sub_type,
                sub_name, sub_name_e, sub_name_c,
                sub_description, sub_description_e, sub_description_c,
                sub_info, sub_info_e, sub_info_c,
                sub_condition,
                sub_data_header, sub_data_contents,
                sub_priority, sub_child, sub_parent, tags
            } = sub;
        
            sub_name_e = this.isFieldEmpty(sub_name_e) ? null : sub_name_e;
            sub_name_c = this.isFieldEmpty(sub_name_c) ? null : sub_name_c;
            sub_description_e = this.isFieldEmpty(sub_description_e) ? null : sub_description_e;
            sub_description_c = this.isFieldEmpty(sub_description_c) ? null : sub_description_c;
            sub_info_e = this.isFieldEmpty(sub_info_e) ? null : sub_info_e;
            sub_info_c = this.isFieldEmpty(sub_info_c) ? null : sub_info_c;
        
            sub_name_e = this.isFieldEmpty(sub_name_e) ? null : sub_name_e;
            sub_name_c = this.isFieldEmpty(sub_name_c) ? null : sub_name_c;
            sub_description_e = this.isFieldEmpty(sub_description_e) ? null : sub_description_e;
            sub_description_c = this.isFieldEmpty(sub_description_c) ? null : sub_description_c;
            sub_info_e = this.isFieldEmpty(sub_info_e) ? null : sub_info_e;
            sub_info_c = this.isFieldEmpty(sub_info_c) ? null : sub_info_c;
            
            tags = this.isFieldEmpty(tags) || !Array.isArray(tags) ? [] : tags;
            sub_data_contents = typeof sub_data_contents === 'string' ? JSON.parse(sub_data_contents) : sub_data_contents;
            sub_condition = this.isFieldEmpty(sub_condition) ? {} : sub_condition;
            sub_child = this.isFieldEmpty(sub_child) ? [] : sub_child;
            
            return {
                sub_code, sub_type,
                sub_name, sub_name_e, sub_name_c,
                sub_description, sub_description_e, sub_description_c,
                sub_info, sub_info_e, sub_info_c,
                sub_condition,
                sub_data_header, sub_data_contents,
                sub_priority, sub_child, sub_parent, tags
            };
        },
        showTranslation (kr, en, ca, lang = this.$i18n.locale) {
            const _locale = lang;
            return _locale === 'ko'
                ? kr
                : _locale === 'ca'
                    ? ca
                    : en;
        },
        formatDate (date, format = 'YYYY-MM-DD HH:mm:ss') {
            if(this.isFieldEmpty(date)) return null;
            let convDate = date;
            if(date.toString().includes('GMT')){
                convDate = date.replace('GMT', '');
            }
            return dayjs(convDate).format(format);
        },
        won_comma (number) {
            if (number === null || typeof number === 'undefined') {
                return String(number).replace(/[^0-9]/g,'').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            } else {
                return String(number).replace(/[^0-9]/g,'').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            }
        },
    }
};
